import React, { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme, Box, Container, Typography, Grid } from '@material-ui/core';
import { LocationIcon } from 'svgs/projects';

interface ProjectsHeaderProps extends StyleProps {
  title: string;
  location: string;
  client?: string;
  servicesProvided: string;
}
type StyleProps = {
  image: string;
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundImage: ({ image }: Partial<StyleProps>) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      padding: theme.spacing(17, 0, 17),
      marginTop: 0,
      minHeight: 400,
      maxHeight: 800,
      backgroundPosition: 'center',
      textAlign: 'center',
      marginBottom: theme.spacing(30),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(17, 0, 17),
        marginTop: theme.spacing(13.5),
      },
    },
    title: {
      color: theme.palette.common.white,
      fontWeight: 700,
      marginBottom: theme.spacing(4),
    },
    text: {
      color: theme.palette.common.white,
      fontWeight: 400,
    },
    locationBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    infoBox: {
      textAlign: 'center',
      backgroundColor: theme.palette.common.white,
      borderBottom: '2px solid #E0621E',
      boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.05)',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: theme.spacing(4, 0),
      marginTop: -240,
      marginBottom: theme.spacing(20),
    },
    divider: {
      height: 56,
      width: 2,
      backgroundColor: theme.palette.secondary.light,
    },

    textBox: {
      marginTop: theme.spacing(4),
      [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(0),
      },
    },
  });
});

const ProjectsHeaderSection: FC<ProjectsHeaderProps> = ({ image, title, location, client, servicesProvided }) => {
  const classes = useStyles({ image });
  return (
    <>
      <Box className={classes.root}>
        <Container fixed>
          <Typography variant="h3" className={classes.title} data-aos="fade-up">
            {title}
          </Typography>
          <Box className={classes.locationBox} data-aos="fade-up" data-aos-delay="300">
            <LocationIcon />
            <Typography variant="h5" className={classes.text}>
              {location}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Container fixed data-aos="fade-up" data-aos-delay="500">
        <Box className={classes.infoBox}>
          <Grid container>
            <Grid item lg={4} xs={12}>
              <Box>
                <Typography variant="h6">Client</Typography>
                <Typography>{client}</Typography>
              </Box>
            </Grid>
            <Grid item lg={4} xs={12}>
              <Box className={classes.textBox}>
                <Typography variant="h6">Location</Typography>
                <Typography>{location}</Typography>
              </Box>
            </Grid>
            <Grid item lg={4} xs={12}>
              <Box className={classes.textBox}>
                <Typography variant="h6">Services Provided</Typography>
                <Typography>{servicesProvided}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default ProjectsHeaderSection;
